import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { T2TemplateBasicComponent } from '../../trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { WorkflowsComponent } from './workflows/workflows.component';
import { BatchHistoryComponent } from './batch-history/batch-history.component';
import { ExportComponent } from '../data-processing/components/export/export.component';
import { PostingComponent } from './posting/posting.component';
import { BilledComponent } from './billed/billed.component';
import { EdiFilesComponent } from './edi-files/edi-files.component';
import { EncountersComponent } from './Encounters/encounters.component';
import { DepositsComponent } from './deposits/deposits.component';


const routes: Routes = [
  {
    path: 'pages',
    component: T2TemplateBasicComponent,
    children: [
      {
        path: 'billingmodule/billingGeneral',
        children: [
          {
            path: 'workflows',
            component: WorkflowsComponent,
            data: { title: 'Workflows' },
          },
          {
            path: 'encounters',
            component: EncountersComponent,
            data: { title: 'Encounters' },
          },
          {
            path: 'batchHistory',
            component: BatchHistoryComponent,
            data: { title: 'Batch History' },
          },
          {
            path: 'exportFile',
            component: ExportComponent,
            data: { title: 'Unverified Trips' },
          },
          {
            path: 'posting',
            component: PostingComponent,
            data: { title: 'Posting' },
          },
          {
            path: 'billed',
            component: BilledComponent,
            data: { title: 'Billed' },
          },
          {
            path: 'ediFiles',
            component: EdiFilesComponent,
            data: { title: 'Edi File Attestation' },
          },
          {
            path: 'deposits',
            component: DepositsComponent,
            data: { title: 'Deposits' },
          },
          {
            path: 'client/invoicebatch',
            loadChildren:
              'app/pages/invoice-batch/invoice-batch.module#InvoiceBatchModule',
          },
          {
            path: 'client',
            loadChildren: 'app/pages/invoice-batch/invoice-batch.module#InvoiceBatchModule'
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class BillingGeneralRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/billing-general-routing.module.ts